Namespace 'CustomerVisualMode.Mappers'

class CustomerVisualMode.Mappers.AllValuesMapper
  @TYPE = 'all'

  constructor: (identifier) ->
    @identifier = identifier
    @type = CustomerVisualMode.Mappers.AllValuesMapper.TYPE

  canHandle: (type) ->
    type == @type

  mapToCompositeFilter: (intelligentGroups) ->
    {included: {type: @type}}

  mapToSearchQuery: (intelligentGroups) ->
    included = intelligentGroups.included
    return {} unless included
    {main_groups: [@identifier]}
